import { Container, Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ReactTooltip from "react-tooltip";
import "react-datepicker/dist/react-datepicker.css";

import FormikControl from "../../../util/formcomponents/FormikControl";
import TextError from "../../../util/formcomponents/TextError";
import PrimaryButton from "../../../util/Btns/PrimaryButton";

import styles from "./AssignRoleModal.module.scss";
import Close from "../../../Assets/close.svg";

import ConsoleLocalStorage from "../../../storage/storage";
import { useCreateProject } from "../../../hooks/DevProjectHooks";
import { useAssignRole } from "../../../hooks/DevAuthHooks";

const roleOptions = [
  {
    key: "Admin",
    value: "admin",
  },
  {
    key: "Developer",
    value: "developer",
  },
  {
    key: "QA",
    value: "qa",
  },
];

const validationSchema = Yup.object().shape({
  role: Yup.string().required("Required"),
});
const AssignRoleModal = ({ showAssignModal, setShowAssignModal, member }) => {
  const { mutate } = useAssignRole(member.id, setShowAssignModal);
  const onSubmit = (values) => {
    mutate(values.role);
  };

  const initialValues = {
    role: member.userType,
  };

  return (
    <>
      <Container>
        <Modal
          show={showAssignModal}
          onHide={() => setShowAssignModal(false)}
          centered
          contentClassName={styles.assignrole}
          dialogClassName={styles.mah_modal}
        >
          <Modal.Header className={styles.title_modal_header}>
            <Modal.Title>
              <div>
                <span
                  style={{ fontFamily: "JioType-Medium", fontSize: "medium" }}
                >
                  Assign role
                </span>
              </div>
            </Modal.Title>
            <img
              onClick={() => setShowAssignModal(false)}
              style={{ marginTop: "15px" }}
              src={Close}
              height="14"
              width="14"
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {(formik) => {
                // console.log(formik);
                return (
                  <Form>
                    <div className={styles.body}>
                      <FormikControl
                        control="radio"
                        options={roleOptions}
                        label=""
                        role={member.userType}
                        name="role"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "1em",
                      }}
                    >
                      <PrimaryButton type="submit">Submit</PrimaryButton>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default AssignRoleModal;
